import {
	FETCH_EVENT_GROUPS,
	FETCH_GROUP,
	CLEAR_GROUPS,
	CLEAR_GROUP,
	CREATE_OR_DUPLICATE_GROUP,
	UPDATE_GROUP,
	DELETE_GROUP,
	ADD_ATTENDEES_TO_GROUP,
	REMOVE_ATTENDEES_FROM_GROUP,
} from '@/redux/actions/actionTypes';

const preState = {
	groups: [],
	selectedGroup: {
		attendees: {
			nodes: [],
		},
	},
};

const groupsReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	let newState;

	const { type, groups, group, groupID, attendeeIDs } = action;

	switch (type) {
		case FETCH_EVENT_GROUPS:
			return { ...stateDup, groups };
		case FETCH_GROUP:
			return { ...stateDup, selectedGroup: { ...group } };
		case CLEAR_GROUP:
			return { ...stateDup, selectedGroup: {} };
		case CLEAR_GROUPS:
			return { ...stateDup, groups: [] };
		case CREATE_OR_DUPLICATE_GROUP:
			return { ...stateDup, groups: [...stateDup.groups, group] };
		case UPDATE_GROUP:
			if (stateDup.selectedGroup.id === group.id)
				stateDup.selectedGroup = { ...stateDup.selectedGroup, ...group };
			stateDup.groups = stateDup.groups.map(g => (g.id === group.id ? { ...g, ...group } : g));
			return { ...stateDup };
		case DELETE_GROUP:
			const filteredGroups = stateDup.groups.filter(g => g.id !== groupID);
			return { selectedGroup: { ...preState.selectedGroup }, groups: [...filteredGroups] };
		case ADD_ATTENDEES_TO_GROUP:
			newState = JSON.parse(JSON.stringify(stateDup));
			newState.selectedGroup.attendees.nodes.push(...attendeeIDs);
			return newState;
		case REMOVE_ATTENDEES_FROM_GROUP:
			const attendeesToRemove = attendeeIDs.map(attendee => attendee.id);
			newState = JSON.parse(JSON.stringify(stateDup));
			newState.selectedGroup.attendees.nodes = newState.selectedGroup.attendees.nodes.filter(
				a => !attendeesToRemove.includes(a.id)
			);
			return newState;
		default:
			return { ...stateDup };
	}
};

export default groupsReducer;
